/* play video slower */

if (document.querySelector('video')) {
    document.addEventListener("DOMContentLoaded", function() {
        document.querySelector('video').playbackRate = 0.5;
    });
}
